<template>
  <span
    v-if="status==='DRAFT'"
    class="badge badge-dark"
  > {{ $t('myRequest.qaralama') }} </span>
  <span
    v-else-if="status==='READY'"
    class="badge badge-primary"
  > {{ $t('supplierOutgoingVendorRequest.hazrdr') }} </span>
  <span
    v-else-if="status==='WAITING'"
    class="badge badge-warning"
  > {{ $t('supplierOutgoingVendorRequest.gzlmd') }} </span>
  <span
    v-else-if="status==='ACTIVE'"
    class="badge badge-success"
  > {{ $t('aktivdir') }} </span>
  <span
    v-else-if="status==='ARCHIVE'"
    class="badge badge-warning"
  > {{ $t('sector.arxiv') }} </span>
  <span
    v-else
    class="badge badge-dark"
  > {{ status }} </span>
</template>
<script>
export default {
  name: 'CompanyFormStatus',
  props: {
    status: ''
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
